<template>
  <div class="main">
    <van-nav-bar
      right-text="交卷"
      left-arrow
      @click-left="back"
    >
      <template #title>
        <div class="title" @click="titleTap()">
          {{ type.text }}<van-icon name="arrow-down" color="#7d7e80" size="12" />
        </div>
      </template>
      <template #right>
        <div >共计{{paperValue}}分</div>
      </template>
    </van-nav-bar>
    <van-loading style="text-align: center" type="spinner" v-if="loading" color="#1989fa" />
    <div class="name-num"  >
      <p>{{title}}--当前题型{{data[this.type.value].typezf}}分</p>
      <div><span>{{ curIndex + 1 }}</span>/{{ curTotal }}</div>
    </div>
    <div class="content">
      <!-- 单选题 -->
      <single-opt v-if="data[type.value].typeid == '1' " :multiple="false" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 多选题 -->
      <single-opt v-if="data[type.value].typeid == '2'" :multiple="true" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 判断题 -->
      <true-or-false v-if="data[type.value].typeid == '3'" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 填空题 -->
      <fill-in v-if="data[type.value].typeid == '4'" @piezfchange="piezfchange" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 问答题 -->
      <q-and-a v-if="data[type.value].typeid == '5'"  @piezfchange="piezfchange" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 理解题 -->
      <comprehension v-if="data[type.value].typeid == '6'" @piezfchange="piezfchange" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 不定项选择题 -->
      <single-opt v-if="data[type.value].typeid == '7'" :multiple="true" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!--排序题 8-->
      <px-info v-if="data[type.value].typeid == '8'" :multiple="true" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 填空题 -->
      <fill-in v-if="data[type.value].typeid == '9'" @piezfchange="piezfchange" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!--固定题型以外题型都已问答题展示-->
      <q-and-a v-if="parseInt(data[type.value].typeid==null || data[type.value].typeid=='' ? '0' : data[type.value].typeid) > 9"  @piezfchange="piezfchange" :data="data[type.value].PaperInfotabList" :active="curIndex" />
    </div>

    <!-- 题型 -->
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <van-picker
        title="题型"
        show-toolbar
        :columns="typeoption"
        @confirm="onConfirm"
        @cancel="onCancel" :key="Math.random()"
      />
    </van-popup>

    <van-tabbar v-model="active" active-color="#7d7e80">
      <van-tabbar-item icon="arrow-left" @click="alterNum('last')">上一题</van-tabbar-item>
      <van-tabbar-item icon="manager" @click="sjshshow">审核</van-tabbar-item>
      <van-tabbar-item icon="arrow" @click="alterNum('next')">下一题</van-tabbar-item>
    </van-tabbar>

    <van-popup v-model="sjshow" style="width: 100%;height: 100%">
<!--    <van-dialog v-model="sjshow" title="试卷审核" :show-confirm-button="false" >-->
      <div>
        <div style="margin: 0 auto;width:85%;">
          <p>课程：{{ formpaper.kcmc }}</p>
          <p>组卷人：{{ formpaper.zjrname }}</p>
          <p>学年学期：{{ formpaper.xnxq }}</p>
          <p>试卷总分：{{ formpaper.paperValue }}</p>
          <p>考试时长：{{ formpaper.examTime }}</p>
          <p>考试日期：{{ formpaper.examDate }}</p>
          <p>试卷类型：{{ typesFormat(formpaper.types) }}</p>
          <p>试卷数量：{{ formpaper.papernumber }}</p>
          <p>考试方式：{{ formpaper.pcorphone=='1'?'PC端考试':'手机端考试' }}</p>
          <p>PC端开启霸屏：{{ formpaper.isfp=='Y'?'开启':'不开启' }}</p>
          <p>题目乱序：{{ formpaper.istd=='Y'?'乱序':'不乱序' }}</p>
          <p>答案选项乱序：{{ formpaper.isad=='Y'?'乱序':'不乱序' }}</p>
          <p>错题入库：{{ formpaper.iswrong=='Y'?'启用':'不启用' }}</p>
          <p>考生收藏：{{ formpaper.iscollection=='Y'?'启用':'不启用' }}</p>
          <p>启用切屏控制：{{ formpaper.isecsc=='Y'?'开启':'不开启' }}&nbsp;
            {{ formpaper.ecsenum !=null?formpaper.ecsenum+'次系统提醒':'' }}
          </p>
          <p>启用人脸识别：{{ formpaper.isface=='Y'?'开启':'不开启' }}&nbsp;
            {{ formpaper.facetime !=null?formpaper.facetime+'分钟自动本人识别':'' }}
          </p>
        </div>
        <div style="padding-top: 10px;padding-bottom: 10px">
          <van-radio-group v-model="formlc.shzt" direction="horizontal" :disabled="iscz">
            <van-radio name="1">审核通过</van-radio>
            <van-radio name="0">审核不通过</van-radio>
          </van-radio-group>
        </div>
        <div style="padding-left: 10px;padding-top: 10px;padding-bottom: 10px" v-if="formlc.kfzj == '1' ? true : false">
          <van-checkbox v-model="formlc.sfzj" shape="square" :disabled="iscz">终结流程</van-checkbox>
        </div>
        <div style="padding-top: 10px;padding-bottom: 10px">
          <van-field v-model="formlc.shyj" type="textarea" label="" placeholder="审核意见" :disabled="iscz" />
        </div>
        <div style="text-align: center">
          <van-button type="info" size="small" @click="beforeClose" >取 消</van-button>
          <van-button type="info" size="small" @click="sjsh" :disabled="iscz">审 核</van-button>
        </div>
        <div style="height: 20px"> </div>
      </div>
    </van-popup>
<!--    </van-dialog>-->
  </div>
</template>
<script>
  import singleOpt from './cuotijicomm/singleOpt'
  import TrueOrFalse from './cuotijicomm/trueOrFalse.vue'
  import fillIn from './cuotijicomm/fillIn.vue'
  import qAndA from './cuotijicomm/qAndA.vue'
  import PxInfo from './cuotijicomm/pxinfo.vue'
  import comprehension from './cuotijicomm/comprehension.vue'
  import sf from '../../utils/somefun.js';
  import {Dialog, Notify} from 'vant';
  import {getDicts,selectDictLabel} from "../../utils/data";

  var timectrl = sf.tc;
  export default {
    components: {
      singleOpt,
      TrueOrFalse,
      fillIn,
      qAndA,
      comprehension,
      PxInfo
    },
    data() {
      return {
        type: {
          text: '单选题',
          value: 0
        },
        curIndex: 0,
        curTotal: 0,
        loading:true,
        active: 0,
        show: false,
        sjshow:false,
        iscz:true,
        typeoption: [],
        title: '',
        data: [{PaperInfotabList:[],typename:'',typeid:'',typerow:'',typezf:''}],
        paperinfo:{},
        pcorphone:null,
        paperId:null,
        paperValue: null,
        piezf:0,
        zf:0,
        // 表单参数
        form: {
          paperid:null,
          ksmxid:null,
          taskid:null,
        },
        formlc:{

        },
        formsh:{

        },
        formpaper:{

        },
        typesOptions:[],
      }
    },
    created() {
      localStorage.setItem('currentpath', this.$router.currentRoute.fullPath);
      this.getLiastPaperInfo();
      getDicts("paper_type").then(response => {
        this.typesOptions = response.data;
      });
    },
    methods: {
      /** 查询试卷试题列表 */
      getLiastPaperInfo(){
        this.formlc = this.$route.params;
        if(this.formlc.shzt === '2'){
          this.iscz = false;
        }
        this.form.paperid = this.$route.params.workid;
        this.paperId = this.$route.params.workid;
        this.formsh.dataid = this.$route.params.dataid;
        this.pcorphone = '2';

        let data = {params:this.form}
        let that = this;
        this.$ajax.get("/papersys/papersh/paperinfo",data).then(response => {
          if(response[0].papertype.length > 0){
            that.data  = response[0].papertype;
            for(let i = 0;i < that.data.length;i++) {
              that.typeoption.push({text:that.data[i].typename,value:i});
              //默认一个
              if(i==0){
                that.type.text=that.data[i].typename;
                that.type.value=i;
                that.curTotal = that.data[i].PaperInfotabList.length;
              }
            }
            that.loading=false;
          }
        });
        this.$ajax.get("/papersys/papersh/"+this.form.paperid).then(res => {
          if (res.code == 200) {
            this.formpaper = res.data;
            this.title = res.data.paperDesc;
            this.paperValue = res.data.paperValue;

          }
        });
      },
      piezfchange()
      {
      },
      calcActive() {
        this.curTotal = this.data[this.type.value].PaperInfotabList.length
      },
      aletrType(type) {
        if (type === 'next') {
          if (this.type.value < this.data.length && this.type.value != this.data.length - 1) {
            this.curIndex = 0
            this.type.value++
            this.type.text = this.typeoption.find(e => {
              return e.value === this.type.value
            }).text
            this.calcActive();
          } else {
            this.$toast('没有更多')
            this.yuejuansubmit(false);
          }
        }
        if (type === 'last') {
          if (this.type.value > 0) {
            this.type.value--
            this.type.text = this.typeoption.find(e => {
              return e.value === this.type.value
            }).text
            this.calcActive()
            this.curIndex = this.curTotal - 1
          } else {
            this.$toast('没有更多')
            this.yuejuansubmit(false);
          }
        }

      },
      alterNum(type) {
        if (type === 'next') {
          if (this.curIndex < this.curTotal - 1) {
            this.curIndex++
          } else {
            // 进入下一题型
            this.aletrType(type)
          }
        }
        if (type === 'last') {
          if (this.curIndex > 0) {
            this.curIndex--
          } else {
            this.aletrType(type)
          }
        }
      },
      titleTap() {
        this.curIndex = 0
        this.show = true
      },
      dropdownChange() {

      },
      onConfirm(e) {
        this.type = e
        this.show = false
        this.calcActive()
      },
      onCancel() {

      },
      back()
      {
        this.$router.push({name: 'sjshindex'})
      },
      yuejuansubmit(istj) {
      },
      sjshshow(){
        this.sjshow = true;
      },
      beforeClose(){
        this.sjshow = false;
      },
      sjsh() {
        this.$dialog.confirm({
          title: "试卷审核",
          message: "确定要审核吗？",
          messageAlign: 'center'
        }).then(() => {
          if (this.formlc.shzt == '1' || this.formlc.shzt == '0') {
            this.formsh.shzt = this.formlc.shzt;
            this.formsh.shyj = this.formlc.shyj;
            this.formsh.sfzj = this.formlc.sfzj;
            this.$ajax.put('/papersys/papersh/sh', this.formsh).then(response => {
              this.$toast('审核成功')
              this.$router.push({name: 'sjshindex'})
            });
          } else {
            this.$toast('请选择审核状态')
          }
        }).catch(() => {

        })
      },
      typesFormat(value) {
        return selectDictLabel(this.typesOptions, value);
      },
    }
  }
</script>
<style lang="scss">
  .main{
    .title{
      i{
        margin-left: .1875rem;
      }
    }
    i.van-icon-clock{
      margin-right: .1875rem;
    }
    .name-num{
      margin: 0 .625rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: .0625rem dashed rgb(235, 234, 234);
      span{
        font-size: 1.875rem;
        color: #7469F8;
      }
    }
    .content{
      padding: 0 .625rem;
    }
  }
  .imgshowdiv{
    position: fixed;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    text-align: center;
    top: 0;
    left: 0;
    background-color: white;

    z-index: 555;
  }
  .facelayer {
    position: fixed;
    width: 100%;
    height: 100%;
    text-align: center;
    top: 0;
    left: 0;
    background-color: white;
    z-index: 999;
  }
  .jjclass{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/teacherpage/sjshdo.vue